import ApiResourceManager from '../ApiResourceManager';

/**
 * Consumer shop root domains (online-orders.com, online-karte.com, …) that
 * service providers link to and franchises are served on. A restaurant's own
 * domain is not one of these: its status is `FranchisesManager.getDomain`.
 */
export default class ShopDomainsManager extends ApiResourceManager {
  /** Platform roots — super-admin only. */
  get = () =>
    this.request({
      method: 'GET',
      url: '/partners/shop-domains',
    });
}
